const handleCaptionMessage = ({
    player,
    firstVideoStarted,
    byMediaCompleteRef,
    captionSettingRef,
    captions,
    appCaptions,
    ENABLED,
    DISABLED,
    SHOWING,
    HIDDEN,
    videoCaptionSubscription
}) => (message) => {
    const { type = '' } = message;
    const mediaPlayerInstance = player?.current;
    const videoPlayer = mediaPlayerInstance?.player;
    const videoEl = videoPlayer?.videoEl;
    const textTrack = videoEl?.textTracks?.[0];
    const mode = textTrack?.mode;
    const activeCues = textTrack?.activeCues;
    const isUsingNativeControls = videoEl?.hasAttribute('controls');
    const isHTML5 = videoPlayer?.playerType === 'HTML5';

    if (!videoPlayer || !mediaPlayerInstance) {
        return;
    };

    if (firstVideoStarted?.current && !isHTML5 && isUsingNativeControls && type === 'MEDIA_STOP') {
        if (!byMediaCompleteRef.current) {
            captionSettingRef.current = mode === SHOWING ? ENABLED : DISABLED;
        } else {
            byMediaCompleteRef.current = false;
        }
        return;
    }

    // If the message type is not 'canplay' or 'MEDIA_STOP', we exit early.
    // Other message types are not relevant to caption handling here and should be ignored.

    if (type !== 'canplay') {
        return;
    };

    const captionsEnabled = !!(captions || appCaptions);

    if (!firstVideoStarted?.current) {
        captionSettingRef.current = captionsEnabled ? ENABLED : DISABLED;
        firstVideoStarted.current = true;

        if (captionSettingRef.current === ENABLED) {
            mediaPlayerInstance.showClosedCaptions(0);
        } else {
            mediaPlayerInstance.hideClosedCaptions();
        }

        if (!isUsingNativeControls) {
            videoCaptionSubscription.current?.unsubscribe?.();
        }

        return;
    }

    if (!activeCues || !isUsingNativeControls) return;

    if (isHTML5) {
        switch (mode) {
            case SHOWING:
                mediaPlayerInstance.showClosedCaptions(0);
                break;
            case HIDDEN:
            case DISABLED:
                mediaPlayerInstance.hideClosedCaptions();
                break;
        }
    } else {
        switch (captionSettingRef.current) {
            case ENABLED:
                if (mode !== SHOWING) {
                    mediaPlayerInstance.showClosedCaptions(0);
                }
                break;
            case HIDDEN:
            case DISABLED:
                if (mode !== SHOWING) {
                    mediaPlayerInstance.hideClosedCaptions();
                }
                break;
        }
    }
};

export default handleCaptionMessage;
